export default {
  女装: "여성 의류",
  男装: "남성",
  手机和小工具: "휴대폰 및 기기",
  居家生活: "가정 생활",
  电脑及周边设备: "컴퓨터 및 주변기기",
  美容及个人护理: "미용 및 개인 관리",
  家用电器: "가전 ​​제품",
  健康与保健: "건강과 웰빙",
  食品和饮料: "음식과 음료",
  玩具_儿童和婴儿: "장난감, 어린이, 아기",
  童装时尚: "어린이 패션",
  视频游戏: "비디오 게임",
  运动与户外: "스포츠 및 야외 활동",
  爱好与书籍: "취미와 책",
  相机和无人机: "카메라와 드론",
  宠物食品及用品: "애완동물 사료 및 용품",
  女士包袋: "여성용 가방",
  男士包袋: "남성용 가방",
  珠宝及配饰: "주얼리 및 액세서리",
  手表: "보다",
  女鞋: "여성화",
  男装鞋: "남자 신발",
  汽车: "자동차",
  我附近的ShopeePay: "내 근처의 ShopeePay",
  餐饮_旅行和服务: "케이터링, 여행 및 서비스",
  旅行及行李: "여행 및 수하물",
  各种各样的: "다양한 종류",
  我是来买什么的: "나는 무엇을 사러 여기에 있습니까?",
  对不起_找不到_相关的商品:
    "죄송합니다. [{0}]과(와) 관련된 제품을 찾을 수 없습니다.",
  类别: "범주",
  产品: "제품",
  店铺: "가게",
  首页: "첫 장",
  限时秒杀: "기간 한정 플래시 세일",
  博客: "블로그",
  所有品牌: "모든 브랜드",
  所有类别: "모든 카테고리",
  我的购物车: "내 장바구니",
  发货信息: "배송정보",
  交货信息: "배송정보",
  付款: "지불",
  确认: "확인하다",
  您的购物车是空的: "귀하의 쇼핑 바구니가 비어 있습니다",
  价格: "가격",
  税: "세",
  数量: "수량",
  总计: "총",
  移除: "제거하다",
  返回商店: "매장으로 돌아가기",
  继续发货: "계속 배송",
  筛选: "필터",
  价格范围: "가격 범위",
  排序方式: "정렬 기준",
  最新: "최신 정보",
  最旧: "가장 오래된",
  价格从低到高: "가격이 낮은 것부터 높은 것 순으로",
  价格从高到低: "가격이 높은 것부터 낮은 것 순으로",
  选择交货类型: "배송 유형 선택",
  送货上门: "배달",
  继续付款: "계속해서 결제하세요",
  任何其他信息: "다른 정보",
  或者: "또는",
  您的钱包余额: "지갑 잔액",
  余额不足: "잔액 불충분",
  支付: "지불하다",
  我同意: "나는 동의한다",
  条款和条件: "이용 약관",
  退货政策: "반품 정책",
  隐私政策: "개인 정보 정책",
  概括: "일반화하다",
  项目: "프로젝트",
  全部的: "모두",
  小计: "소계",
  总运费: "총 배송비",
  有优惠码吗_在这里输入: "할인 코드가 있나요? 여기에 입력",
  申请: "적용하다",
  编辑: "편집하다",
  删除: "삭제",
  添加新地址: "새 주소 추가",
  继续交货信息: "계속 배송정보",
  选择一个地址: "주소를 선택하세요",
  购买历史: "구매 내역",
  下载: "다운로드",
  已发送退款请求: "환불 요청이 전송되었습니다.",
  对比: "비교됨",
  对话: "대화",
  我的钱包: "내 지갑",
  工单: "작업 순서",
  管理个人资料: "프로필 관리",
  登出: "로그아웃",
  重置对比列表: "비교 목록 재설정",
  您的对比列表为空: "비교 목록이 비어 있습니다.",
  在您的购物车中: "장바구니에",
  在您的愿望清单中: "당신의 위시리스트에",
  在您的预定列表中: "예약 목록에",
  下载您的产品: "제품 다운로드",
  选项: "옵션",
  什么都没找到: "아무것도 찾을 수 없음",
  特色产品: "주요 제품",
  最畅销: "베스트셀러",
  前_名: "상위 {0}",
  查看更多: "더보기",
  查看所有类别: "모든 카테고리 보기",
  十大品牌: "상위 10개 브랜드",
  查看所有品牌: "모든 브랜드 보기",
  登录: "로그인",
  手机号码: "전화 번호",
  密码: "비밀번호",
  密码长度为6到16个字符: "비밀번호 길이는 6~16자입니다.",
  验证码: "확인 코드",
  登录中: "로그인",
  游客登录: "방문자 로그인",
  注册您的商店: "매장 등록",
  现在申请: "지금 신청하세요",
  成为商家: "판매자가 되세요",
  现在注册: "지금 등록하세요",
  登录成功: "성공적으로 착륙했습니다",
  通知: "통지하다",
  未找到通知: "알림을 찾을 수 없습니다",
  评论: "논평",
  估计运输时间: "예상 배송 시간",
  天: "하늘",
  所售: "판매된",
  给商家留言: "판매자에게 메시지를 남겨주세요",
  规格: "사양",
  库存: "재고",
  总价: "총 가격",
  添加到购物车: "장바구니에 추가",
  立即购买: "지금 구매하세요",
  缺货: "품절",
  添加到愿望清单: "위시리스트에 추가",
  加入对比列表: "비교 목록에 추가",
  退款: "환불하다",
  查看条款: "약관 보기",
  分享: "공유하다",
  描述: "설명하다",
  相关产品: "관련 상품",
  没有人问过商家: "아무도 상인에게 묻지 않았습니다.",
  该产品暂无评论: "이 제품에 대한 리뷰가 아직 없습니다.",
  客户评论: "고객 리뷰",
  访问商店: "매장 방문",
  畅销产品: "베스트 셀러",
  日期: "날짜",
  订单编号: "주문 번호",
  总额: "일시금",
  状态: "상태",
  愿望清单: "위시리스트",
  还没有添加任何东西: "아직 추가된 내용이 없습니다.",
  注册: "등록하다",
  邀请码: "초대 코드",
  请输入邀请码: "초대코드를 입력해주세요",
  用户名: "사용자 이름",
  请输入用户名: "사용자 이름을 입력하세요",
  用户名长度为6_14个字符: "사용자 이름 길이는 6~14자입니다.",
  昵称: "닉네임",
  请输入手机号码: "전화번호를 입력해주세요",
  手机号码格式错误: "전화번호 형식이 잘못되었습니다.",
  密码长度为6_16个字符: "비밀번호 길이는 6~16자입니다.",
  确认密码: "비밀번호 확인",
  请输入确认密码: "확인 비밀번호를 입력해주세요",
  提款密码: "출금 비밀번호",
  请输入提款密码: "출금 비밀번호를 입력해주세요",
  提款密码长度为4_16个字符: "출금 비밀번호 길이는 4~16자입니다.",
  请输入验证码: "인증번호를 입력해주세요",
  在_s后发送: "{0}초 후에 전송됨",
  发送验证码: "인증 코드 보내기",
  注册即表示您同意我们的条款和条件: "가입하시면 이용약관에 동의하게 됩니다.",
  创建账号: "계정 만들기",
  验证码发送成功: "인증코드가 성공적으로 전송되었습니다",
  确认密码不一致: "비밀번호가 일치하지 않는지 확인하세요.",
  提款密码必须为数字: "출금 비밀번호는 숫자여야 합니다",
  注册成功: "등록 성공",
  购物车: "쇼핑 카트",
  账户: "계정",
  我的账户: "내 계정",
  已经有一个账户: "이미 계정이 있습니다",
  新地址: "새 주소",
  编辑地址: "주소 수정",
  保存: "구하다",
  是否默认: "기본값인가요?",
  具体地址: "특정 주소",
  请输入具体地址: "구체적인 주소를 입력해주세요",
  地区: "영역",
  请输入地区: "지역을 입력해주세요",
  城市: "도시",
  请输入城市: "도시를 입력하세요",
  省份: "주",
  请输入省份: "도를 입력해주세요",
  邮政编码: "우편 번호",
  请输入邮政编码: "우편번호를 입력해주세요",
  电话号码: "전화 번호",
  请输入电话号码: "전화번호를 입력해주세요",
  收货人: "수화기",
  请输入收货人: "수취인을 입력해주세요",
  保存成功: "성공적으로 저장 되었음",
  最畅销的商家: "베스트셀러 판매자",
  查看所有的商家: "모든 업체 보기",
  支持政策: "지원 정책",
  您的电子邮件地址: "귀하의 이메일 주소",
  订阅: "신청",
  联系方式: "연락처 정보",
  地址: "주소",
  美国伊利诺伊州霍夫曼庄园: "호프만 에스테이츠, 일리노이주, 미국",
  快速链接: "빠른 링크",
  商家政策: "판매자 정책",
  submit: "제출하다",
  提款银行卡: "출금은행카드",
  我的面板: "내 패널",
  提示: "힌트",
  确定登出吗: "정말로 로그아웃하시겠습니까?",
  确定: "확신하는",
  取消: "취소",
  项目添加到您的购物车: "장바구니에 상품 추가",
  经常一起购买: "자주 함께 사세요",
  返回购物: "쇼핑으로 돌아가기",
  进行结算: "결제를 진행하세요",
  帮助热线: "헬프라인",
  查看所有通知: "모든 알림 보기",
  请输入密码: "비밀번호를 입력 해주세요",
  前往充值: "재충전하러 가기",
  购物车物品: "장바구니 항목",
  查看购物车: "장바구니를 확인해 보세요",
  钱包余额: "지갑 잔액",
  充值钱包: "지갑 충전",
  钱包充值_线下_: "지갑 충전(오프라인)",
  申请提款: "탈퇴 신청",
  钱包收支明细: "지갑 수입 및 지출 내역",
  批准: "승인하다",
  提现历史记录: "출금 내역",
  类型: "유형",
  信息: "정보",
  付款方式: "결제수단",
  请选择付款方式: "결제수단을 선택해주세요",
  Bill_Type_RECHARGE_BACK: "백엔드 재충전",
  Bill_Type_RECHARGE_ONLINE: "온라인 충전",
  Bill_Type_RECHARGE_REGISTER: "무료로 등록하세요",
  Bill_Type_RECHARGE_JACKPOT: "재충전 보너스",
  Bill_Type_RECHARGE_PRESENT: "보상 충전",
  Bill_Type_RECHARGE_FROM_COMMISSION: "커미션 양도",
  Bill_Type_RECHARGE_TG_COMMISSION: "재충전 프로모션 수수료",
  Bill_Type_REGISTER_TG_COMMISSION: "등록촉진위원회",
  Bill_Type_WITHDRAW: "철회하다",
  Bill_Type_WITHDRAW_REJECT: "출금이 거부됨",
  Bill_Type_DEDUCT_HANDLE: "수동 공제",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "재충전 보정",
  Bill_Type_MINING_PROFIT: "채굴 수입",
  Bill_Type_MINING_PROFIT_COMMISSION: "광업소득증진위원회",
  Bill_Type_VIP_UPGRADE: "VIP 업그레이드",
  Bill_Type_FINANCE_BUY: "금융상품 구매",
  Bill_Type_FINANCE_CAPITAL_RETURN: "재정 잔고 반환",
  Bill_Type_FINANCE_FEE: "재무 관리 수수료",
  Bill_Type_FINANCE_PROFIT: "재무관리수익",
  Bill_Type_FINANCE_BUY_COMMISSION: "금융상품구매수수료",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "금융상품소득 수수료",
  Bill_Type_WHEEL_DRAW: "큰 바퀴 복권",
  Bill_Type_BUY: "물건을 사다",
  Bill_Type_PAY_SHOP: "배송비 지불",
  Bill_Type_BUY_COMMISSION: "구매한 품목에 대한 수수료",
  Bill_Type_DEPOSIT: "보증금 지불",
  Bill_Type_STORE_BUY: "물건을 사다",
  Bill_Type_STORE_BUY_REFUND: "구매상품 환불",
  Bill_Type: "계정 변경 유형",
  Before_Money: "이전 금액",
  Deal_Money: "계좌변경금액",
  After_Money: "이후 금액",
  Bill_Time: "계정 변경 시간",
  No_More_Data: "더 이상 데이터가 없습니다",
  Apply_Money: "신청금액",
  Apply_Time: "신청 시간",
  Withdraw_Info: "처리 수수료: {fee}, 도착: {money}",
  提款订单状态_CHECKING: "검토를 보류하다",
  提款订单状态_TRANSFERRING: "전송 중",
  提款订单状态_PASS: "확인됨",
  提款订单状态_REJECT: "해고됨",
  暂无可用充值方式: "아직 사용 가능한 충전 방법이 없습니다.",
  钱包收款码: "지갑 결제 코드",
  钱包地址: "지갑 주소",
  金额限制: "금액 한도",
  复制: "복사",
  付款凭证: "지불 바우처",
  收款银行: "수취은행",
  收款人: "수취인",
  收款账号: "결제계좌번호",
  付款银行: "지불 은행",
  付款人: "지불인",
  付款账号: "지불 계좌",
  请输入付款银行: "결제은행을 입력해주세요",
  请输入付款人: "지불인을 입력해주세요",
  请输入付款账号: "결제계좌번호를 입력해주세요",
  请上传付款凭证: "결제 바우처를 업로드해주세요.",
  充值金额: "충전금액",
  请输入充值金额: "충전금액을 입력해주세요",
  submitting: "제출 중...",
  Confirm: "제출하다",
  Commit_Success: "성공적으로 제출되었습니다",
  balanceType_BALANCE: "균형",
  balanceType_COMMISSION: "수수료",
  Balance: "계정 잔액",
  Wash_Money: "모자이크 추가",
  请选择银行账户: "은행계좌를 선택해주세요",
  卡号类型: "카드번호 종류",
  提现金额: "출금금액",
  提款金额: "출금금액",
  不能为空: "비워둘 수 없습니다.",
  金额不正确: "금액이 정확하지 않습니다.",
  please_input_withdraw_password: "출금 비밀번호를 입력해주세요",
  withdraw_password_format_error: "출금 비밀번호는 4~16자여야 합니다.",
  Fee: "수수료",
  实际到账: "실제 도착",
  交易币种: "거래통화",
  原始密码: "원래 비밀번호",
  confirm_password_error: "두 번 입력한 비밀번호가 올바르지 않습니다.",
  save_success: "성공적으로 저장 되었음",
  please_input: "들어 오세요",
  old_password: "기존 비밀번호",
  new_password: "새 비밀번호",
  please_input_confirm_password: "비밀번호를 다시 확인해 주세요",
  没有找到符合条件的商品: "일치하는 제품이 없습니다.",
  Search: "찾다",
  全部: "모두",
  EnumGoodsOrderState_USER_PAY: "배송 대기",
  EnumGoodsOrderState_SHOP_PAY: "전달",
  EnumGoodsOrderState_SUCCESS: "마치다",
  EnumGoodsOrderState_CANCEL: "취소 된",
  EnumGoodsOrderState_REFUND_SUCCESS: "환불됨",
  订单号: "주문 번호",
  用户名称: "사용자 이름",
  收益: "소득",
  支付时间: "결제 시간",
  配送时间: "배달 시간",
  完成时间: "완료 시간",
  发货: "배",
  全选: "모두 선택",
  物品已添加到愿望清单: "위시리스트에 추가된 상품",
  物品已添加到比较列表: "비교 목록에 항목이 추가되었습니다.",
  购买成功提示: "축하합니다. 구매가 성공적으로 이루어졌습니다.",
  订单列表: "주문 목록",
  商品名: "상품명",
  图片: "그림",
  没有品牌: "노 브랜드",
  基本信息: "기본 정보",
  Account_Name: "계좌 개설 이름",
  Bank_Account: "은행 계좌",
  Bank_Phone: "휴대폰번호 예약",
  IFSC: "IFSC 계정",
  UPI: "UPI 계정",
  PIX: "PIX 계정",
  CPF: "CPF 계좌",
  GCASH: "GCASH 계정",
  POWWI: "POWWI 계정",
  身份证号: "ID 번호",
  Edit: "개정하다",
  Delete: "삭제",
  Add: "새로운",
  Forget_Withdraw_Password: "출금 비밀번호를 잊어버렸습니다",
  Bank_Card_Info: "은행 카드 정보",
  收款人地址: "수취인 주소",
  SWIFT: "빠른",
  Bank_Branch: "지점명",
  分行代码: "지점 코드",
  银行地址: "계좌 번호",
  Email: "이메일",
  银行卡长度必须超过: "은행 카드 길이는 {length}을(를) 초과해야 합니다.",
  银行卡格式不正确: "은행 카드 형식이 올바르지 않습니다.",
  Do_you_confirm_delete: "삭제를 확인하시겠습니까?",
  Please_Login_First: "먼저 로그인을 해주세요",
  Bank_Name: "은행 이름",
  Please_add_bank_first:
    "아직 은행카드를 연결하지 않았습니다. 먼저 카드를 추가하세요.",
  withdrawType: "출금 유형",
  withdraw_money_limit:
    "인출 금액은 0보다 크고 {balance}보다 작거나 같아야 합니다.",
  withdraw_times_limit:
    "오늘 {todayWithdrawNum}회 인출했으며, {limitTimes}회 이후에는 {withdrawFee}%의 처리 수수료가 청구됩니다. 정말 탈퇴하시겠습니까?",
  Copy_Success: "성공적으로 복사되었습니다",
  商店首页: "매장 홈페이지",
  所有产品: "모든 상품",
  新到货产品: "새로 도착한 제품",
  所有商家: "모든 판매자",
  请上传: "업로드해주세요",
  请输入: "들어 오세요",
  忘记密码: "비밀번호를 잊어버려",
  记得我: "날 기억해",
  共_件: "총 {0}개 항목",
  取消订单: "주문 취소",
  申请退款: "환불 요청",
  未知商家: "알 수 없는 판매자",
  到账: "영수증",
  提款订单状态: "출금주문현황",
  前_名类别: "상위 {0} 카테고리",
  取消订单原因_不想要了: "더 이상 원하지 않아",
  取消订单原因_商品错选_多选: "잘못된 제품 선택/다중 선택",
  取消订单原因_商品无货: "제품 품절",
  取消订单原因_地址信息填写错误: "주소 정보가 잘못 입력되었습니다.",
  取消订单原因_商品降价: "제품 가격 인하",
  取消订单原因_价格高于其他平台: "가격이 다른 플랫폼보다 높음",
  取消订单原因_没用_少用_错用优惠: "할인 미사용/적게 사용/오용",
  退款原因_拍错_多拍_不喜欢: "잘못된 샷 / 추가 샷 / 마음에 들지 않음",
  退款原因_商品成分描述不符: "제품 성분 설명이 일치하지 않습니다.",
  退款原因_与商家协商一致退款: "판매자와 합의한 대로 환불",
  退款原因_生产日期_保质期与商品描述不符:
    "생산일자/유통기한이 상품 설명과 일치하지 않습니다.",
  退款原因_图片_产地_批号_规格等描述不符:
    "사진/원산지/배치번호/사양 및 기타 설명이 일치하지 않습니다.",
  退款原因_质量问题: "품질 문제",
  退款原因_商品变质_发霉_有异物: "제품이 부패/곰팡이/이물질이 있음",
  退款原因_少件_含缺少配件_: "부품 수가 적음(부속품 누락 포함)",
  退款原因_收到商品时有破损_污渍_变形:
    "상품을 받았을 때 손상/얼룩/변형이 있었습니다.",
  退款原因_假冒品牌: "위조 브랜드",
  退款原因_发票问题: "송장 문제",
  退款原因_商家发错货: "판매자가 물건을 잘못 보냈어요",
  退款原因_预约不到_商家不给退换:
    "예약할 수 없음/판매자가 환불이나 교환을 제공하지 않음",
  退款失败: "환불 실패",
  退款处理中: "환불 진행 중",
  默认: "기본",
  产品查询: "상품검색",
  商店LOGO: "매장 로고",
  推广码: "프로모션 코드",
  查看所有: "모두보기",
  确认收货成功: "상품 수령이 성공적으로 확인되었습니다.",
  物流公司: "물류회사",
  物流单号: "운송 번호",
  发货时间: "배송 시간",
  请先选择商品规格: "제품 사양을 먼저 선택해주세요.",
  个人信息: "개인 정보",
  您的用户名: "당신의 사용자 이름",
  你的名字: "당신의 이름",
  登录名: "사용자 이름",
  你的邮件: "귀하의 이메일",
  你的密码: "너의 비밀번호",
  重复输入密码: "비밀번호를 반복하세요",
  店铺名称: "가게 이름",
  证书类型: "인증서 유형",
  身份证: "신분증",
  护照: "여권",
  驾驶执照: "운전 면허증",
  社会保障卡: "사회 보장 카드",
  证书正面: "인증서 앞면",
  证书反面: "인증서 뒷면",
  确认收货: "물품 수령을 확인하다",
  请选择取消订单的原因必选: "주문 취소 사유를 선택해주세요(필수):",
  请选择申请退款的原因必选: "환불요청사유를 선택해주세요(필수):",
  留言: "메시지",
  请输入留言: "메시지를 입력해주세요",
  没有帐户: "계정 없음",
  钱包充值: "지갑 재충전",
  输入您的文字: "텍스트를 입력하세요",
  商家登录: "판매자 로그인",
  有关此产品的任何查询: "본 상품에 대한 문의사항은",
  产品名称: "상품명",
  你的问题: "너의 문제",
  白银店铺: "은 가게",
  铂金店铺: "플래티넘 스토어",
  钻石店铺: "다이아몬드 가게",
  照片: "사진",
  已退货: "반환됨",
  邮寄状态: "메일링 상태",
  订单摘要: "주문 요약",
  收件地址: "수취인 주소",
  订购日期: "주문일",
  订单状态: "주문 상태",
  总订单金额: "총 주문 금액",
  邮寄方式: "메일링 방법",
  附加信息: "추가 정보",
  订单详细信息: "주문 세부정보",
  交货类型: "배송 유형",
  进行评论: "댓글을 달아주세요",
  已评论: "댓글이 달림",
  订单金额: "주문량",
  优惠券: "쿠폰",
  统一运费: "정액 배송비",
  送货地址: "배송 주소",
  评分: "점수",
  你的意见: "당신의 의견",
  匿名: "익명의",
  现金: "현금",
  详情: "세부",
  收货地址: "배송 주소",
  暂时没有对话: "아직 대화가 없습니다.",
  你: "너",
  输入您的回复: "답장을 입력하세요",
  删除成功: "성공적으로 삭제되었습니다",
  品牌: "상표",
  已缴纳的保证金: "보증금 지불됨",
  黄金店铺: "금 매장",
  没有更多数据: "더 이상 데이터가 없습니다",
  站内信: "사이트 메시지",
  系统通知: "시스템 알림",
  邮箱: "우편",
  手机号: "전화 번호",
  你的手机号: "전화 번호",
  营业执照: "영업 허가증",
  你的邮箱: "당신의 사서함",
  搜索结果: "검색 결과",
  系统公告: "시스템 알림",
  加入对比: "비교에 추가",
  佣金余额: "커미션 잔액",
  刷新: "새로 고치다",
  刷新成功: "새로고침 성공",
  官网: "공식 웹 사이트",
  税号: "세금 ID 번호",
  订单: "주문하다",
  合计: "총",
  系统安全: "시스템 보안",
  Recharge_Money_Limit: "재충전 금액은 {min}에서 {max} 사이여야 합니다.",
  限时优惠: "기간 한정 혜택",
  高价回收: "고가 재활용",
  姓名: "이름",
  商品订单号: "제품 주문번호",
  商品在线回收: "제품 온라인 재활용",
  提交: "제출하다",
  回收记录: "재활용 기록",
  回收状态: "재활용 현황",
  回收价格: "재활용 가격",
  纳税码: "세금 코드",
  买家登录: "로그인",
  买家注册: "등록하다",
  language: "韩语",
  客服: "고객 서비스",
  消息已撤回: "뉴스가 철회되었습니다",
  物流详情: "물류 세부 사항",
  充值: "위로",
  提现: "철회하다",
  信用分: "신용 거래",
  余额: "균형",
  佣金: "수수료",
  继续购物: "쇼핑을 계속하십시오",
  订单结算: "주문 합의",
  助力提示:
    "가맹점을 돕는 것은 플랫폼의 상점에 대한 노출을 증가시킬 수 있고 누적 일수가 높을수록 노출이 높아집니다.",
  已累计助力: "누적 적으로 도움이되었습니다",
  今日已助力: "오늘은 도움이되었습니다",
  立即助力: "즉시 도와주세요",
  商家助力: "가맹점 도움",
  证件号码: "ID 번호",
  证书号码: "인증서 번호",
  男鞋: "남자 신발",
  游戏玩具: "게임 장난감",
  使用条款: "이용 약관",
  商家: "상인",
  已助力: "도움이되었습니다",
  被助力: "도움을 받고 있습니다",
  用户: "사용자",
  助力记录: "레코드를 도와주세요",
  消息类型: "메시지 유형",
  消息内容: "메시지 내용",
  链接: "링크",
  文本: "텍스트",
  清空: "분명한",
  评论成功: "댓글 성공",
  扫描二维码: "QR 코드를 스캔하세요",
  转入: "편입",
  收款: "수집",
  任务下单中心: "작업지시센터",
  记录: "기록",
  任务倒计时: "작업 카운트다운",
  倒计时后自动放弃: "카운트다운 후 자동 포기",
  业务码: "사업 코드",
  选择商品分类: "제품 카테고리 선택",
  可多选: "다중 선택 가능",
  加载分类中: "카테고리 로딩 중",
  暂无分类: "아직 분류가 없습니다.",
  产品类别: "제품 카테고리",
  账户余额: "계좌잔고",
  立即结算: "즉시 정산",
  任务已自动放弃: "작업이 자동으로 중단되었습니다.",
  商品分类: "제품 분류",
  订单详情: "주문 세부정보",
  预计收益: "예상 수익",
  预计佣金收益: "예상 수수료 수입",
  收益率: "수확량",
  扣款账户: "직불 계좌",
  确认结算: "정산 확인",
  未选择: "선택되지 않음",
  请选择商品分类: "제품 카테고리를 선택해주세요.",
  下单成功: "주문이 성공적으로 완료되었습니다",
  下单失败: "주문 실패",
  请重试: "다시 시도해 주세요",
  订单记录: "주문기록",
  没有更多了: "더 이상",
  业务号: "사업자번호",
  商品类型: "제품 유형",
  佣金收益: "수수료 수입",
  待结算: "결제 대기 중",
  已结算: "정착됨",
  已取消: "취소됨",
  加载失败: "로드 실패",
  倒计时: "카운트다운",
  随机商品: "무작위 아이템",
  为: "에 대한",
  商户助力可提升商品曝光度: "판매자 지원을 통해 제품 노출을 늘릴 수 있습니다.",
  累计助力越高推荐权重越高: "누적된 지원이 높을수록 추천 가중치도 높아집니다.",
  实时助力动态: "실시간 지원 역학",
  助力奖励: "보상 강화",
  随机奖励金额已生成: "무작위 보상 금액이 생성되었습니다",
  开心收下: "기쁘게 받아들인다",
  助力已结束: "도움말이 종료되었습니다",
  助力成功: "성공을 도와주세요",
  成功: "성공",
  进行中: "진행 중",
  等待: "잠깐",
  助力失败: "도움말 실패",
  任務: "작업",
  下单失败_请稍后重试: "주문 실패, 나중에 다시 시도하세요",
  任务: "일"
};
